export default "__VITE_ASSET__DwaxXci3__"